import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { version as e } from "../../kernel.js";
import s from "../Error.js";
import { on as t } from "../events.js";
import { isSome as o } from "../maybe.js";
import { onAbortOrThrow as r, createAbortError as i, isPromiseLike as n, isAbortError as a } from "../promiseUtils.js";
import { newJobId as l, MessageType as c, receiveMessage as p, toInvokeError as h, postMessage as u } from "./utils.js";
import { commitHash as _, buildDate as d } from "../../support/revision.js";
var m = {
  statsWorker: function statsWorker() {
    return import("../../smartMapping/statistics/support/statsWorker.js");
  },
  geometryEngineWorker: function geometryEngineWorker() {
    return import("../../geometry/geometryEngineWorker.js");
  },
  CSVSourceWorker: function CSVSourceWorker() {
    return import("../../layers/graphics/sources/support/CSVSourceWorker.js");
  },
  EdgeProcessingWorker: function EdgeProcessingWorker() {
    return import("../../views/3d/webgl-engine/lib/edgeRendering/EdgeProcessingWorker.js");
  },
  ElevationSamplerWorker: function ElevationSamplerWorker() {
    return import("../../geometry/support/meshUtils/ElevationSamplerWorker.js");
  },
  FeatureServiceSnappingSourceWorker: function FeatureServiceSnappingSourceWorker() {
    return import("../../views/interactive/snapping/featureSources/featureServiceSource/FeatureServiceSnappingSourceWorker.js");
  },
  GeoJSONSourceWorker: function GeoJSONSourceWorker() {
    return import("../../layers/graphics/sources/geojson/GeoJSONSourceWorker.js");
  },
  LercWorker: function LercWorker() {
    return import("../../layers/support/LercWorker.js");
  },
  MemorySourceWorker: function MemorySourceWorker() {
    return import("../../layers/graphics/sources/support/MemorySourceWorker.js");
  },
  PBFDecoderWorker: function PBFDecoderWorker() {
    return import("../../views/3d/support/PBFDecoderWorker.js");
  },
  Pipeline: function Pipeline() {
    return import("../../views/2d/layers/features/Pipeline.js");
  },
  PointCloudWorker: function PointCloudWorker() {
    return import("../../views/3d/layers/PointCloudWorker.js");
  },
  RasterWorker: function RasterWorker() {
    return import("../../layers/support/RasterWorker.js");
  },
  SceneLayerWorker: function SceneLayerWorker() {
    return import("../../views/3d/layers/SceneLayerWorker.js");
  },
  WFSSourceWorker: function WFSSourceWorker() {
    return import("../../layers/graphics/sources/WFSSourceWorker.js");
  },
  WorkerTileHandler: function WorkerTileHandler() {
    return import("../../views/2d/engine/vectorTiles/WorkerTileHandler.js");
  }
},
    g = c.CLOSE,
    b = c.ABORT,
    k = c.INVOKE,
    v = c.RESPONSE,
    y = c.OPEN_PORT,
    j = c.ON;

var f = /*#__PURE__*/function () {
  function f(e) {
    _classCallCheck(this, f);

    this._timer = null, this._cancelledJobIds = new Set(), this._invokeMessages = [], this._invoke = e, this._timer = null, this._process = this._process.bind(this);
  }

  _createClass(f, [{
    key: "push",
    value: function push(e) {
      e.type === c.ABORT ? this._cancelledJobIds.add(e.jobId) : (this._invokeMessages.push(e), null === this._timer && (this._timer = setTimeout(this._process, 0)));
    }
  }, {
    key: "clear",
    value: function clear() {
      this._invokeMessages.length = 0, this._cancelledJobIds.clear(), this._timer = null;
    }
  }, {
    key: "_process",
    value: function _process() {
      this._timer = null;

      var _iterator = _createForOfIteratorHelper(this._invokeMessages),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          this._cancelledJobIds.has(_e.jobId) || this._invoke(_e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._cancelledJobIds.clear(), this._invokeMessages.length = 0;
    }
  }]);

  return f;
}();

var M = /*#__PURE__*/function () {
  function M(e, s) {
    var _this = this;

    _classCallCheck(this, M);

    this._port = e, this._outJobs = new Map(), this._inJobs = new Map(), this._invokeQueue = new f(function (e) {
      return _this._onInvokeMessage(e);
    }), this._client = s.client, this._onMessage = this._onMessage.bind(this), this._channel = s.channel, this._schedule = s.schedule, this._port.addEventListener("message", this._onMessage), this._port.start();
  }

  _createClass(M, [{
    key: "close",
    value: function close() {
      this._post({
        type: g
      }), this._close();
    }
  }, {
    key: "isBusy",
    value: function isBusy() {
      return this._outJobs.size > 0;
    }
  }, {
    key: "invoke",
    value: function invoke(e, t, o) {
      var _this2 = this;

      var n = o && o.signal,
          a = o && o.transferList;
      if (!this._port) return Promise.reject(new s("worker:port-closed", "Cannot call invoke('".concat(e, "'), port is closed"), {
        methodName: e,
        data: t
      }));
      var c = l();
      return new Promise(function (s, o) {
        var l = r(n, function () {
          var e;

          var s = _this2._outJobs.get(c);

          s && (_this2._outJobs.delete(c), null == (e = s.abortHandle) || e.remove(), _this2._post({
            type: b,
            jobId: c
          }), o(i()));
        }),
            p = {
          resolve: s,
          reject: o,
          abortHandle: l,
          debugInfo: e
        };
        _this2._outJobs.set(c, p), _this2._post({
          type: k,
          jobId: c,
          methodName: e,
          abortable: null != n
        }, t, a);
      });
    }
  }, {
    key: "on",
    value: function on(e, s) {
      var t = new MessageChannel();

      function o(e) {
        s(e.data);
      }

      return this._port.postMessage({
        type: c.ON,
        eventType: e,
        port: t.port2
      }, [t.port2]), t.port1.addEventListener("message", o), t.port1.start(), {
        remove: function remove() {
          t.port1.postMessage({
            type: c.CLOSE
          }), t.port1.close(), t.port1.removeEventListener("message", o);
        }
      };
    }
  }, {
    key: "openPort",
    value: function openPort() {
      var e = new MessageChannel();
      return this._post({
        type: y,
        port: e.port2
      }), e.port1;
    }
  }, {
    key: "_close",
    value: function _close() {
      this._channel && (this._channel = null), this._port.removeEventListener("message", this._onMessage), this._port.close(), this._outJobs.forEach(function (e) {
        var s;
        null == (s = e.abortHandle) || s.remove(), e.reject(i("Worker closing, aborting job calling '".concat(e.debugInfo, "'")));
      }), this._inJobs.clear(), this._outJobs.clear(), this._invokeQueue.clear(), this._port = this._client = this._schedule = null;
    }
  }, {
    key: "_onMessage",
    value: function _onMessage(e) {
      var _this3 = this;

      o(this._schedule) ? this._schedule(function () {
        return _this3._processMessage(e);
      }) : this._processMessage(e);
    }
  }, {
    key: "_processMessage",
    value: function _processMessage(e) {
      var s = p(e);
      if (s) switch (s.type) {
        case v:
          this._onResponseMessage(s);

          break;

        case k:
          this._invokeQueue.push(s);

          break;

        case b:
          this._onAbortMessage(s);

          break;

        case g:
          this._onCloseMessage();

          break;

        case y:
          this._onOpenPortMessage(s);

          break;

        case j:
          this._onOnMessage(s);

      }
    }
  }, {
    key: "_onAbortMessage",
    value: function _onAbortMessage(e) {
      var s = this._inJobs,
          t = e.jobId,
          o = s.get(t);
      this._invokeQueue.push(e), o && (o.controller && o.controller.abort(), s.delete(t));
    }
  }, {
    key: "_onCloseMessage",
    value: function _onCloseMessage() {
      var e = this._client;
      this._close(), e && "destroy" in e && M.clients.get(this) === e && e.destroy(), M.clients.delete(this), e && e.remoteClient && (e.remoteClient = null);
    }
  }, {
    key: "_onInvokeMessage",
    value: function _onInvokeMessage(e) {
      var _this4 = this;

      var s = e.methodName,
          t = e.jobId,
          o = e.data,
          r = e.abortable,
          i = r ? new AbortController() : null,
          l = this._inJobs;
      var c,
          p = this._client,
          u = p[s];

      try {
        if (!u && s && -1 !== s.indexOf(".")) {
          var _e2 = s.split(".");

          for (var _s = 0; _s < _e2.length - 1; _s++) {
            p = p[_e2[_s]], u = p[_e2[_s + 1]];
          }
        }

        if ("function" != typeof u) throw new TypeError("".concat(s, " is not a function"));
        c = u.call(p, o, {
          client: this,
          signal: i ? i.signal : null
        });
      } catch (_) {
        return void this._post({
          type: v,
          jobId: t,
          error: h(_)
        });
      }

      n(c) ? (l.set(t, {
        controller: i,
        promise: c
      }), c.then(function (e) {
        l.has(t) && (l.delete(t), _this4._post({
          type: v,
          jobId: t
        }, e));
      }, function (e) {
        l.has(t) && (l.delete(t), a(e) || _this4._post({
          type: v,
          jobId: t,
          error: h(e || {
            message: "Error encountered at method ".concat(s)
          })
        }));
      })) : this._post({
        type: v,
        jobId: t
      }, c);
    }
  }, {
    key: "_onOpenPortMessage",
    value: function _onOpenPortMessage(e) {
      new M(e.port, {
        client: this._client
      });
    }
  }, {
    key: "_onOnMessage",
    value: function _onOnMessage(e) {
      var s = e.port,
          o = this._client.on(e.eventType, function (e) {
        s.postMessage(e);
      }),
          r = t(e.port, "message", function (e) {
        p(e).type === c.CLOSE && (r.remove(), o.remove(), s.close());
      });
    }
  }, {
    key: "_onResponseMessage",
    value: function _onResponseMessage(e) {
      var t;
      var o = e.jobId,
          r = e.error,
          i = e.data,
          n = this._outJobs;
      if (!n.has(o)) return;
      var a = n.get(o);
      n.delete(o), null == (t = a.abortHandle) || t.remove(), r ? a.reject(s.fromJSON(JSON.parse(r))) : a.resolve(i);
    }
  }, {
    key: "_post",
    value: function _post(e, s, t) {
      return u(this._port, e, s, t);
    }
  }], [{
    key: "connect",
    value: function connect(e) {
      var s = new MessageChannel();
      var t;
      t = "function" == typeof e ? new e() : "default" in e && "function" == typeof e.default ? new e.default() : e;
      var o = new M(s.port1, {
        channel: s,
        client: t
      });
      return "object" == typeof t && "remoteClient" in t && (t.remoteClient = o), M.clients.set(o, t), s.port2;
    }
  }, {
    key: "loadWorker",
    value: function loadWorker(e) {
      var s = m[e];
      return s ? s() : Promise.resolve(null);
    }
  }]);

  return M;
}();

M.kernelInfo = {
  revision: _,
  version: e,
  buildDate: d
}, M.clients = new Map();
export { M as default };